import styled, { createGlobalStyle } from 'styled-components';

export const ChatbotAssistantDrawerStyles = createGlobalStyle`
  .modal.chatbot-assistant-drawer-modal {
    padding-left: 0;
    padding-right: 0;
    font-family: 'Roboto', sans-serif;
    pointer-events: none;
  }

  .modal.chatbot-assistant-drawer-modal .modal-dialog.chatbot-assistant-drawer-dialog {
    position: fixed;
    right: 0;
    top: 0;
    bottom: 0;
    left: auto;
    margin: 0;
    width: min(100vw, var(--bidding-chat-drawer-width, 46.2rem));
    max-width: min(100vw, var(--bidding-chat-drawer-width, 46.2rem));
    height: 100vh;
    max-height: 100vh;
    transform: translateX(100%);
    transition: transform 0.3s ease-out, width 0.3s ease-out, max-width 0.3s ease-out;
  }

  .modal.chatbot-assistant-drawer-modal .modal-dialog.chatbot-assistant-drawer-dialog--expanded {
    width: min(100vw, calc(var(--bidding-chat-drawer-width, 46.2rem) * 1.8));
    max-width: min(100vw, calc(var(--bidding-chat-drawer-width, 46.2rem) * 1.8));
  }

  .modal-backdrop.chatbot-assistant-drawer-backdrop {
    opacity: 0.5;
  }

  .modal.chatbot-assistant-drawer-modal.show .modal-dialog.chatbot-assistant-drawer-dialog {
    transform: translateX(0);
  }

  .modal.chatbot-assistant-drawer-modal .chatbot-assistant-drawer-content {
    height: 100vh;
    max-height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    pointer-events: auto;
    padding: 0;
    border: 0;
    border-top-left-radius: 0.3rem;
    border-bottom-left-radius: 0.3rem;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    background: #41526b;
  }
`;

export const Container = styled.div`
  &.chatbot-assistant-container {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0;
    min-width: 0;
    font-family: 'Roboto', sans-serif;
  }

  .chatbot {
    background: ${(props) => props.theme.$deep_police_blue};
    color: black;
    min-height: 0;
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;

    &-body {
      position: relative;
      flex: 1;
      min-height: 0;
    }

    &-tab {
      flex-shrink: 0;

      &-nav {
        border-radius: 0;
        padding: 10px 15px;
        border: 0;
        border-bottom: 2px solid ${(props) => props.theme.$manatee};
        position: relative;

        &:hover {
          background: ${(props) => props.theme.$dark_electric_blue};
        }

        &.current {
          border-bottom-color: ${(props) => props.theme.$primary_green_light};
        }
      }

      .btn-chatbot:hover {
        opacity: 0.5;
      }
    }

    &-line {
      height: 2px;
      background: ${(props) => props.theme.$manatee};
      margin-top: -2px;
      flex-shrink: 0;
    }

    &-messages {
      position: absolute;
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 100%;
      overflow-x: hidden;
      overflow-y: scroll;
      scrollbar-color: ${(props) => props.theme.$dark_electric_blue}
        ${(props) => props.theme.$deep_police_blue};
      scrollbar-width: thin;
    }

    &-form {
      background: ${(props) => props.theme.$black_coral};
      position: sticky;
      bottom: 0;
      flex-shrink: 0;

      .chatbot-input-group {
        width: 100%;
        display: flex;
        gap: 10px;
      }

      .btn-chatbot-send {
        background: ${(props) => props.theme.$white};
        color: ${(props) => props.theme.$charcoal};
        border-radius: 0px;
        &:disabled {
          cursor: default;
        }
      }

      .btn-chatbot-audio span {
        background: transparent;
        color: ${(props) => props.theme.$white};
        border-radius: 0px;
        padding: 2px;
        &:disabled {
          cursor: default;
        }
        &:hover {
          background: ${(props) => props.theme.$dark_electric_blue};
          padding: 2px;
          border-radius: 4px;
        }
      }
    }

    &-input {
      width: calc(100% - 40px);
      color: ${(props) => props.theme.$white};
      border-radius: 4px 0 0 4px;
      padding: 15px;
      overflow-y: scroll;
      overflow-x: hidden;
      word-break: break-word;
      max-height: 85px;
      min-height: 52px;
      outline: none;
      scrollbar-color: ${(props) => props.theme.$charcoal} ${(props) => props.theme.$black_coral};
      scrollbar-width: thin;

      &:empty::before,
      &:has(br:only-child)::before {
        content: 'Como posso te ajudar?';
        color: ${(props) => props.theme.$gray400};
      }

      &:not(:empty)::before {
        content: '';
      }

      &[contentEditable='true']:focus {
        &::before {
          content: '';
        }
      }

      &[contentEditable='false'] {
        opacity: 0.5;
      }

      &-group {
        background-color: ${(props) => props.theme.$charcoal};
        border: 1px solid ${(props) => props.theme.$white};
        color: ${(props) => props.theme.$white};
        border-radius: 4px;
      }
    }

    &-audio {
      &-control {
        display: flex;
        min-height: 52px;
      }
      &-recording {
        display: flex;
        align-items: center;
        padding-left: 15px;
        width: calc(100% - 40px);
      }
      &-equalizer-bars {
        display: flex;
        align-items: flex-end;
        gap: 3px;
        height: 20px;

        span {
          width: 3px;
          height: 6px;
          background: #fff;
          border-radius: 2px;
          animation: equalizer 1s infinite ease-in-out;
        }

        span:nth-child(1) {
          animation-delay: 0s;
        }
        span:nth-child(2) {
          animation-delay: 0.15s;
        }
        span:nth-child(3) {
          animation-delay: 0.3s;
        }

        @keyframes equalizer {
          0% {
            height: 6px;
            opacity: 0.4;
          }
          50% {
            height: 18px;
            opacity: 1;
          }
          100% {
            height: 6px;
            opacity: 0.4;
          }
        }
      }
      &-cancel,
      &-submit {
        color: #fff;
      }
    }
    .chatbot-notice {
      color: ${(props) => props.theme.$white}90;
      font-size: 0.8rem;
    }
  }

  .btn-chatbot-history {
    width: 100%;
    border: 0;
    border-bottom: 1px solid ${(props) => props.theme.$manatee};
    background: transparent;

    &:hover {
      background: ${(props) => props.theme.$dark_electric_blue};
    }
  }

  .message {
    color: white;

    &-box {
      width: 100%;
      display: grid;
      grid-template-areas:
        'author date date'
        'text text text';
    }

    &-text {
      word-break: break-word;
      grid-area: text;
    }

    &-date {
      grid-area: date;
    }

    &-author {
      grid-area: author;
      display: flex;
      justify-content: space-between;
      color: ${(props) => props.theme.$white};

      .author-avatar {
        display: none;
      }

      .chatbot-avatar {
        margin-right: 0.8em;
      }
    }

    &-date,
    .chatbot-rating {
      font-size: 12px;
    }

    &-loading {
      opacity: 0.5;

      &.chatbot-typing-indicator {
        display: inline-flex;
        align-items: baseline;
        gap: 0.28rem;
        opacity: 1;
        color: rgba(255, 255, 255, 0.82);
        font-size: 0.875rem;
        line-height: 1;
      }
    }

    .chatbot-typing-dots {
      display: inline-flex;
      align-items: center;
      gap: 0.14rem;

      span {
        width: 3px;
        height: 3px;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.55);
        opacity: 0.55;
        animation: bwChatTypingDotAssist 1.05s ease-in-out infinite;
      }

      span:nth-child(2) {
        animation-delay: 0.14s;
      }

      span:nth-child(3) {
        animation-delay: 0.28s;
      }
    }

    @media (prefers-reduced-motion: reduce) {
      .chatbot-typing-dots span {
        animation: none;
        opacity: 0.72;
      }
    }

    .btn-rating {
      opacity: 0.5;
      color: ${(props) => props.theme.$white};

      &.rated {
        opacity: 1;
      }

      span {
        font-size: 20px;
      }
    }
  }

  .user {
    background: ${(props) => props.theme.$charcoal};
  }

  .assistant {
    background: ${(props) => props.theme.$deep_police_blue};
  }

  @keyframes bwChatTypingDotAssist {
    0%,
    80%,
    100% {
      opacity: 0.5;
      transform: translateY(0);
    }
    40% {
      opacity: 1;
      transform: translateY(-2px);
    }
  }
`;
